import type { Tour } from '../../types';

export const workflowsTour: Tour = {
  id: 'institution-workflows',
  name: 'Workflow Approvals Tour',
  description: 'Learn how to manage document approval workflows',
  category: 'institution',
  showProgress: true,
  requiredPath: '/workflows',
  steps: [
    {
      id: 'workflows-1',
      target: 'workflows-header',
      title: 'Workflow Management',
      content: 'Workflows route documents through approval chains. Define who needs to approve documents and in what order.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'workflows-2',
      target: 'workflows-pending',
      title: 'Pending Approvals',
      content: 'Documents waiting for your approval appear here. Review the document and take action to approve, reject, or request changes.',
      position: 'right',
      spotlight: true,
    },
    {
      id: 'workflows-3',
      target: 'workflows-my-requests',
      title: 'My Requests',
      content: 'Track documents you\'ve submitted for approval. See their current status and which approver they\'re waiting on.',
      position: 'right',
      spotlight: true,
    },
    {
      id: 'workflows-4',
      target: 'workflows-templates',
      title: 'Workflow Templates',
      content: 'Create reusable workflow templates for common approval processes. Define stages, approvers, and escalation rules.',
      position: 'left',
      spotlight: true,
    },
    {
      id: 'workflows-5',
      target: 'workflows-action-btns',
      title: 'Take Action',
      content: 'When reviewing a document, you can approve, reject, or request revisions. Add comments to explain your decision.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'workflows-6',
      target: 'workflows-history',
      title: 'Approval History',
      content: 'View the complete approval history for any document: who approved, when, and any comments they added.',
      position: 'left',
      spotlight: true,
      actionLabel: 'Finish Tour',
    },
  ],
};
